import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const DialogsContainer = styled('div')({
    borderRight: '1px solid #E4EAEB',
    padding: '13px 16px 0',
    '@media (max-width: 1024px)': {
        padding: '0 16px',
        borderRight: 'none',
    },
});

export const ConversationsWrapper = styled('div')(({ isEmpty, hasConversationId }) => ({
    willChange: 'scroll-position',
    transition: '300ms ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    height: hasConversationId ? 'calc(var(--100vh) - 124px)' : 'calc(var(--100vh) - 69px)',
    ...(isEmpty && {
        justifyContent: 'center',
        alignItems: 'center',
    }),
    '@media (max-width: 1024px)': {
        height: hasConversationId ? 'calc(var(--100vh) - 248px)' : 'calc(var(--100vh) - 197px)',
    },
}));

export const ScopeHeader = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '4px 0',
});

export const ChipsRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '4px 0 12px',
});

export const StatusToggle = styled('button', {
    shouldForwardProp: prop => prop !== 'active',
})(({ active }) => ({
    fontFamily: 'Rubik, sans-serif',
    fontSize: 13,
    fontWeight: 500,
    lineHeight: '18px',
    padding: '4px 14px',
    borderRadius: 99,
    cursor: 'pointer',
    transition: 'background-color 0.15s ease-in-out',
    ...(active
        ? {
              backgroundColor: 'var(--primary-main)',
              color: '#fff',
              border: '1px solid var(--primary-main)',
          }
        : {
              backgroundColor: 'transparent',
              color: 'var(--text-secondary)',
              border: '1px solid rgba(0, 0, 0, 0.23)',
              '&:hover': {
                  backgroundColor: 'var(--action-hover)',
              },
          }),
}));

export const ConversationsToolbar = styled('div')({
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    marginBottom: '24px',
    padding: '0 16px',
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiSvgIcon-root': {
        fontSize: '1.125rem',
    },
    '& .MuiCheckbox-root': {
        padding: 0,
    },
});

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
    },
    '& .modal-base-content': {
        padding: '24px 16px',
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '8px',
    gridTemplateColumns: '100%',
});
